"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainController = void 0;
const ethers_1 = require("ethers");
const alchemyKey = 'kcuWVV9ss_iLWJ2Lw6xdHbmtZYixfY7Z';
const rpcUrls = {
    MUMBAI: `https://polygon-mumbai.g.alchemy.com/v2/${alchemyKey}`, //'https://polygon-mumbai.blockpi.network/v1/rpc/public',
    ETH: 'https://eth.llamarpc.com',
    POLYGON: `https://polygon-mainnet.g.alchemy.com/v2/${alchemyKey}`, // 'https://polygon.llamarpc.com',
    AVALANCHE: 'https://avalanche-c-chain.publicnode.com',
    ARBITRUM: 'https://arbitrum-one.publicnode.com',
    BINANCE: 'https://bsc.publicnode.com',
    OPTIMISM: 'https://optimism.meowrpc.com',
    FANTOM: 'https://fantom.publicnode.com',
    FUSE: 'https://rpc.fuse.io',
    MANTA: 'https://1rpc.io/manta',
    'MANTA-TESTNET': 'https://manta-testnet.calderachain.xyz/http',
    METIS: 'https://metis-pokt.nodies.app',
    'METIS-TESTNET': 'https://goerli.gateway.metisdevops.link',
    MANTLE: 'https://rpc.mantle.xyz',
    'MANTLE-TESTNET': 'https://rpc.testnet.mantle.xyz',
};
class ChainController {
    constructor(chainName, rpcUrl) {
        // @ts-ignore
        this.rpcUrl = rpcUrl || rpcUrls[chainName];
    }
    readContract(contractDetails) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { contractAddress, abi, functionName, args } = contractDetails;
                const { contract } = yield this.getContract(contractAddress, abi);
                // Invoke the contract function
                const data = yield contract[functionName](...args);
                // Handle the result
                // console.log('readContract', data);
                return { success: true, data };
            }
            catch (error) {
                console.error(error);
                return { success: false, message: 'Error reading contract', error };
            }
        });
    }
    getContract(contractAddress, abi) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const contractAbi = abi;
                const contract = new ethers_1.ethers.Contract(contractAddress, contractAbi, this.getProvider());
                return {
                    contract,
                };
            }
            catch (err) {
                throw new Error('Error making contract instance');
            }
        });
    }
    getProvider() {
        const providerInstance = new ethers_1.ethers.providers.JsonRpcProvider(this.rpcUrl);
        return providerInstance;
    }
    waitForTransaction(txnHash, confirmations, timeout) {
        return __awaiter(this, void 0, void 0, function* () {
            const txn = yield this.getProvider().waitForTransaction(txnHash, confirmations, timeout);
            return txn;
        });
    }
}
exports.ChainController = ChainController;
